/*! Pip's VTT Maps bundles third-party code, under the licences below.
 *
 * Mappadux — FrunkQ — MIT — https://github.com/FrunkQ/dynamic-map-renderer-v2
 *   Copyright (c) 2026 FrunkQ
 *   Used for the magic-wand fog fill (src/mapfx/floodFill.ts) and the aurora, embers, light and static
 *   backdrop effects (src/mapfx/shaders/).
 * Ocean shader — afl_ext — MIT — via Mappadux
 *   Copyright (c) 2017-2024 afl_ext
 *   Used for the ocean backdrop.
 * React — Meta Platforms, Inc. and affiliates — MIT — https://github.com/facebook/react
 *   Copyright (c) Meta Platforms, Inc. and affiliates.
 * supabase-js — Supabase — MIT — https://github.com/supabase/supabase-js
 *   Copyright (c) 2020 Supabase
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
 * associated documentation files (the "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial
 * portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO
 * EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR
 * THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");
createRoot(root).render(<StrictMode><App /></StrictMode>);
